import Link from 'next/link';
import Icon from '@/components/ui/AppIcon';

const EmptyCart = () => {
  return (
    <div className="flex min-h-[60vh] flex-col items-center justify-center px-4 py-12">
      <div className="mb-6 flex h-32 w-32 items-center justify-center rounded-full bg-muted">
        <Icon name="ShoppingCartIcon" size={64} className="text-text-secondary" />
      </div>

      <h2 className="mb-3 font-heading text-2xl font-semibold text-text-primary">
        Ваша корзина пуста
      </h2>

      <p className="mb-8 max-w-md text-center font-caption text-base text-text-secondary">
        Добавьте товары из каталога, чтобы начать оформление оптового заказа
      </p>

      <div className="flex flex-col gap-3 sm:flex-row">
        <Link
          href="/product-catalog"
          className="flex items-center justify-center gap-2 rounded-md bg-accent px-8 py-3 font-heading text-base font-semibold text-accent-foreground shadow-sm transition-all duration-250 hover:bg-accent/90 hover:shadow-md focus:outline-none focus:ring-2 focus:ring-accent focus:ring-offset-2 active:scale-[0.97]"
        >
          <Icon name="Squares2X2Icon" size={20} />
          <span>Перейти в каталог</span>
        </Link>

        <Link
          href="/homepage"
          className="flex items-center justify-center gap-2 rounded-md border border-border bg-background px-8 py-3 font-heading text-base font-medium text-text-primary transition-all duration-250 hover:bg-muted focus:outline-none focus:ring-2 focus:ring-accent focus:ring-offset-2 active:scale-[0.97]"
        >
          <Icon name="HomeIcon" size={20} />
          <span>На главную</span>
        </Link>
      </div>

      <div className="mt-12 grid max-w-2xl grid-cols-1 gap-4 sm:grid-cols-3">
        <div className="flex flex-col items-center gap-2 rounded-md bg-card p-4 text-center shadow-sm">
          <Icon name="CubeIcon" size={32} className="text-accent" />
          <h3 className="font-heading text-sm font-semibold text-text-primary">
            Оптовые цены
          </h3>
          <p className="font-caption text-xs text-text-secondary">
            Выгодные условия для оптовых покупателей
          </p>
        </div>

        <div className="flex flex-col items-center gap-2 rounded-md bg-card p-4 text-center shadow-sm">
          <Icon name="ClipboardDocumentCheckIcon" size={32} className="text-accent" />
          <h3 className="font-heading text-sm font-semibold text-text-primary">
            Простое оформление
          </h3>
          <p className="font-caption text-xs text-text-secondary">
            Быстрая подача заявки на оптовый заказ
          </p>
        </div>

        <div className="flex flex-col items-center gap-2 rounded-md bg-card p-4 text-center shadow-sm">
          <Icon name="UserGroupIcon" size={32} className="text-accent" />
          <h3 className="font-heading text-sm font-semibold text-text-primary">
            Поддержка менеджера
          </h3>
          <p className="font-caption text-xs text-text-secondary">
            Персональная обработка каждой заявки
          </p>
        </div>
      </div>
    </div>
  );
};

export default EmptyCart;